var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalTemplateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F2F4F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#F9FAFB",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 19H34C34.5304 19 35.0391 19.2107 35.4142 19.5858C35.7893 19.9609 36 20.4696 36 21V35C36 35.5304 35.7893 36.0391 35.4142 36.4142C35.0391 36.7893 34.5304 37 34 37H22C21.4696 37 20.9609 36.7893 20.5858 36.4142C20.2107 36.0391 20 35.5304 20 35V21C20 20.4696 20.2107 19.9609 20.5858 19.5858C20.9609 19.2107 21.4696 19 22 19H24M25 17H31C31.5523 17 32 17.4477 32 18V20C32 20.5523 31.5523 21 31 21H25C24.4477 21 24 20.5523 24 20V18C24 17.4477 24.4477 17 25 17Z",
    stroke: "#3E444C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalTemplateIcon);
export default __webpack_public_path__ + "static/media/modal-template-icon.fb8e25941e017d17736f8587026f68af.svg";
export { ForwardRef as ReactComponent };